__webpack_require__.p = "/skillz/";